<template lang="pug">
  section#search-form.search.container
    search-header
    keep-alive
      component(:is="form")
</template>
<script>
import ExpertForm from './ExpertForm'
import { mapState, } from 'vuex'
import SimpleForm from './SimpleForm'
import SearchHeader from './SearchHeader'

export default {
  components: {
    SearchHeader,
    SimpleForm,
    ExpertForm,
  },
  computed: {
    form () {
      return this.expertMode ? ExpertForm : SimpleForm
    },

    ...mapState('search', [ 'expertMode', ]),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"

  #search-form
    padding 25px 70px
    background-color $default-color-light-2
    border-radius 8px
    border 2px solid $default-color-light-1
    flex-direction column
  @media (max-width: $laptop)
    #search-form
      order 3
      padding 30px 30px
      border-radius 0
      border none
      border-bottom 1px solid $default-color-light-1

  @media (max-width: $tablet)
    #search-form
      background-color transparent
</style>



// WEBPACK FOOTER //
// src/components/search-components/SearchForm.vue